import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

import axios from 'axios'
Vue.prototype.$axios = axios

import '@/plugins/vant.js'

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
